export const beverageCategories = [
  { id: 'all', label: 'All Drinks' },
  { id: 'beer', label: 'Beer' },
  { id: 'wine', label: 'Wine' },
  { id: 'spirits', label: 'Spirits' },
  { id: 'soft', label: 'Soft Drinks' },
  { id: 'energy', label: 'Energy Drinks' },
  { id: 'water', label: 'Water' },
  { id: 'extras', label: 'Extras' },
];

export const beverages = [
  {
    id: '1',
    name: 'Banks Beer',
    category: 'beer',
    price: 850,
    originalPrice: null,
    image: 'https://public.readdy.ai/ai/img_res/9d5c56642194a6786e9acf8ce1b3ba74.jpg',
    rating: 4.8,
    reviews: 234,
    badge: 'Best Seller',
    deliveryTime: '25 min',
    volume: '330ml',
  },
  {
    id: '9',
    name: 'Heineken',
    category: 'beer',
    price: 1000,
    originalPrice: null,
    image: 'https://readdy.ai/api/search-image?query=Heineken%20green%20beer%20bottle%20cold%20condensation%20white%20clean%20minimal%20background%20product%20photography%20premium%20lager%20refreshing%20imported&width=400&height=480&seq=bev9&orientation=portrait',
    rating: 4.7,
    reviews: 312,
    badge: 'Imported',
    deliveryTime: '25 min',
    volume: '330ml',
  },
  {
    id: '10',
    name: 'Corona Extra',
    category: 'beer',
    price: 1050,
    originalPrice: null,
    image: 'https://readdy.ai/api/search-image?query=Corona%20Extra%20beer%20clear%20bottle%20lime%20wedge%20cold%20tropical%20beach%20Caribbean%20white%20clean%20background%20product%20photography%20refreshing%20Mexican%20lager&width=400&height=480&seq=bev10&orientation=portrait',
    rating: 4.6,
    reviews: 278,
    badge: 'Imported',
    deliveryTime: '25 min',
    volume: '330ml',
  },
  {
    id: '2',
    name: 'El Dorado Rum',
    category: 'spirits',
    price: 4500,
    originalPrice: 5200,
    image: 'https://readdy.ai/api/search-image?query=El%20Dorado%20dark%20rum%20bottle%20luxury%20amber%20Demerara%20Guyana%20spirits%20product%20photography%20white%20background%20elegant&width=400&height=480&seq=bev2&orientation=portrait',
    rating: 4.9,
    reviews: 189,
    badge: 'Local Pride',
    deliveryTime: '25 min',
    volume: '750ml',
  },
  {
    id: '3',
    name: 'Carib Lager',
    category: 'beer',
    price: 750,
    originalPrice: null,
    image: 'https://readdy.ai/api/search-image?query=Carib%20lager%20beer%20can%20cold%20refreshing%20Caribbean%20tropical%20green%20white%20background%20product%20photo%20crisp%20bubbles&width=400&height=480&seq=bev3&orientation=portrait',
    rating: 4.6,
    reviews: 156,
    badge: null,
    deliveryTime: '20 min',
    volume: '330ml',
  },
  {
    id: '4',
    name: 'D\'Vine Sorrel Wine',
    category: 'wine',
    price: 2800,
    originalPrice: null,
    image: 'https://readdy.ai/api/search-image?query=sorrel%20hibiscus%20wine%20bottle%20deep%20red%20Caribbean%20tropical%20white%20clean%20background%20product%20photography%20elegant%20glass%20bottle&width=400&height=480&seq=bev4&orientation=portrait',
    rating: 4.7,
    reviews: 98,
    badge: 'Local Pick',
    deliveryTime: '30 min',
    volume: '750ml',
  },
  {
    id: '5',
    name: 'Coca-Cola',
    category: 'soft',
    price: 300,
    originalPrice: null,
    image: 'https://readdy.ai/api/search-image?query=Coca-Cola%20bottle%20cold%20refreshing%20ice%20condensation%20red%20white%20product%20photography%20clean%20white%20background%20beverage&width=400&height=480&seq=bev5&orientation=portrait',
    rating: 4.5,
    reviews: 412,
    badge: null,
    deliveryTime: '20 min',
    volume: '500ml',
  },
  {
    id: '6',
    name: 'Red Bull Energy',
    category: 'energy',
    price: 950,
    originalPrice: null,
    image: 'https://readdy.ai/api/search-image?query=Red%20Bull%20energy%20drink%20can%20silver%20wings%20refreshing%20product%20photography%20clean%20white%20background%20cold%20beverage%20boost&width=400&height=480&seq=bev6&orientation=portrait',
    rating: 4.4,
    reviews: 203,
    badge: null,
    deliveryTime: '20 min',
    volume: '250ml',
  },
  {
    id: '7',
    name: 'Stag Beer',
    category: 'beer',
    price: 780,
    originalPrice: null,
    image: 'https://readdy.ai/api/search-image?query=Stag%20beer%20bottle%20Trinidad%20Caribbean%20golden%20amber%20lager%20cold%20refreshing%20white%20background%20product%20photography&width=400&height=480&seq=bev7&orientation=portrait',
    rating: 4.5,
    reviews: 167,
    badge: null,
    deliveryTime: '25 min',
    volume: '330ml',
  },
  {
    id: '11',
    name: 'Itaipava',
    category: 'beer',
    price: 920,
    originalPrice: null,
    image: 'https://readdy.ai/api/search-image?query=Itaipava%20Brazilian%20beer%20bottle%20cold%20golden%20pale%20lager%20condensation%20water%20drops%20white%20clean%20minimal%20background%20product%20photography%20refreshing%20crisp%20Brazil%20imported&width=400&height=480&seq=bev11&orientation=portrait',
    rating: 4.5,
    reviews: 74,
    badge: 'Brazilian Import',
    deliveryTime: '25 min',
    volume: '350ml',
  },
  {
    id: '8',
    name: 'Pure Water Pack',
    category: 'water',
    price: 450,
    originalPrice: null,
    image: 'https://readdy.ai/api/search-image?query=purified%20water%20bottle%20pack%20crystal%20clear%20refreshing%20clean%20white%20background%20product%20photography%20hydration%20tropical&width=400&height=480&seq=bev8&orientation=portrait',
    rating: 4.3,
    reviews: 88,
    badge: 'Healthy',
    deliveryTime: '20 min',
    volume: '1.5L x 6',
  },
  {
    id: '12',
    name: 'Ice Cubes Bag 5kg',
    category: 'extras',
    price: 600,
    originalPrice: null,
    image: 'https://readdy.ai/api/search-image?query=clear%20plastic%20bag%20filled%20with%20clean%20pure%20ice%20cubes%20frozen%20water%20transparent%20packaging%20cold%20refreshing%20white%20minimal%20clean%20studio%20background%20product%20photography&width=400&height=480&seq=bev12&orientation=portrait',
    rating: 4.6,
    reviews: 52,
    badge: 'Essential',
    deliveryTime: '20 min',
    volume: '5kg bag',
  },
];
